export default "__VITE_ASSET__bPy7vRZb__"